var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<header id=\"contact-header\" class=\"contact-header\"></header><div id=\"contact-errors\"></div><div id=\"contact-form\"></div>");;return buf.join("");
};
module.exports = template;